import { createSlice } from '@reduxjs/toolkit'

export const scrollBarSlice = createSlice({
  name: "scrollbar",
  initialState: {
    scrollHeight: 0,
  },
  reducers: {
    scrollEvent: (state, action) => {
      return action.payload; 
    },
  },
});

export const { scrollEvent } = scrollBarSlice.actions;

// the format of this selection depends on store
export const selectScrollHeight = (state) => {
  return state.scroll.scrollHeight
}; 

export const scrollHeightReducer = scrollBarSlice.reducer;

export default scrollBarSlice.reducer;